<template>
  <div class="ButtonUpload">
    <div class="ButtonUpload__button">
      <label
      for="fileUploadInput"
      class="ButtonUpload__label">Upload File</label>
      <input
      type="file"
      id="fileUploadInput"
      ref="fileUploadInput"
      @change="onFileChange"
      class="ButtonUpload__input"
      :multiple="true">
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ButtonUpload',

  methods: {
    ...mapActions('filesTransfer', [
      'pushFileUpload'
    ]),
    onFileChange (e) {
      const fileList = e.target.files || e.dataTransfer.files
      const parentItemId = this.$route.params.folderId
      Array.from(fileList).forEach(file => {
        this.pushFileUpload({ file, parentItemId })
      })
      this.resetFileInput()
    },
    resetFileInput () {
      this.$refs.fileUploadInput.type = ''
      this.$refs.fileUploadInput.type = 'file'
    }
  }
}
</script>

<style lang="scss">
.ButtonUpload {
  margin-bottom: 8px;
  position: relative;

  &__button {
    width: 168px;
    height: 32px;
    color: $white;
    background-color: $brand-primary;
    border-radius: 4px;
    border: none;
    padding: 0;
    &:hover {
      color: $white;
      background-color: $brand-primary-hover;
    }
  }

  &__label {
    position: absolute;
    cursor: pointer;
    top:0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__input {
    display: none;
  }
}
</style>
